// Eager slim slice of the tickets component barrel (#16 tickets slim).
//
// The full `./index.js` barrel `export *`s all 24 tickets component files
// (~620KB — the whole board/kanban/triage/roadmap/resolutions UI tree). The
// unified shell used to drag ALL of it into its EAGER chunk by folding the
// tickets context via `sharedLibraries.js` (`import tickets from
// '@symbo-ls/workspace-tickets'` → smbls's mergeSharedLibraries folds the full
// components+functions+state into the boot root context).
//
// Tickets is now a lazy sub-app: the `/tickets*` + `/resolutions*` routes fold
// the FULL tickets context into the live shell context on first mount
// (workspace/pages/index.js → lazySharedLibPage). So every tickets UI key those
// routes reference resolves against the folded context — none of the heavy
// page-body components (GeneralMain ~100KB, ResolutionsMain, DailyUpdate,
// ReleaseMain, MyViewMain, TicketsKanban, StoryDetailModal, TicketCard,
// RoadmapMain, …) needs to be eager.
//
// Only TWO component files stay eager, because non-tickets surfaces reference
// their keys BEFORE any /tickets* route folds the context — and none of those
// surfaces fold tickets on their own. (TicketDetailModal.js left this slice on
// 2026-10-02: the shell root still bare-keys `TicketsDetailModal` behind its
// `if:` latch, but the module is now loaded and folded on first need by
// workspace/functions/ticketDetailModalLoad.js — smbls element >= 3.14.798
// re-merges the parked element with the late-registered component.)
//   • ActivityHeatmap.js — `TicketsActivityHeatmap` is bare-keyed on the HOME
//     dashboard (main.js). Fully self-contained (its childExtends
//     TicketsActivityRow / TicketsHeatmapCell live in-file; no cross-tickets
//     imports).
//   • Sidebar.js — `TicketsSidebar` is bare-keyed by `/tickets/status`
//     (features.js) and `TicketsSidebarGroup` is string-extended by the house
//     sidebar idiom across EAGER + other-lazy surfaces: canvas
//     (CanvasViewSidebar, ProjectCanvasSidebar), infra (InfraSidebar), workspace
//     GreenIG pages (claims/customers/transactions/policies), and shared
//     (CanvasViewNav). Its childExtends (TicketsSidebarItem, TicketsTypeBtn) +
//     extends (TicketsAssigneePicker, TicketsIssuerPicker, TicketsSidebarGroup)
//     all live in-file.
//
// The el.call'd functions these three fire on those non-folding surfaces
// (saveTicket / deleteTicket / moveTicket from the modal;
// reloadTickets from the sidebar; freshTicket from chat's MessageList) ride the
// companion functions/eagerSlice.js. Everything else resolves via the lazy fold.
//
// tickets/package.json has no `sideEffects: false`, so a re-export through
// `./index.js` would NOT tree-shake (referencing it evaluates every sibling
// source file — the whole 620KB barrel). Each key below is therefore `export *`-ed
// from its SOURCE file directly, so only these three modules ride the eager chunk.
export * from './ActivityHeatmap.js'
export * from './Sidebar.js'
